<script lang="ts" setup>
import { Carousel } from '@/common/components/carousel';
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data: imgList } = useAsyncData(
  'home:banner',
  () => $fetch('/operator/getOperatorList', { method: 'post', data: { operateType: 2 } }),
);
</script>

<template>
  <section class="page-home-banner h-400 w-880 rounded-6 shadow-[0_1px_6px_0_rgba(0,0,0,0.04)]">
    <Carousel.Root class="relative overflow-x-hidden" autoplay loop v-if="imgList?.length">
      <Carousel.Context v-slot="{ pages }">
        <Carousel.ItemGroup>
          <Carousel.Item class="h-400" v-for="(item, idx) in imgList" :key="idx" :index="idx">
            <a class="block size-full" :href="item.jumpUrl" target="_blank" :aria-label="`${$t('home.common.carousel.jumpToUrl', { url: item.jumpUrl }) }`">
              <img :src="item.picUrl" :alt="item.operateName" class="block size-full rounded-6 object-cover">
            </a>
          </Carousel.Item>
        </Carousel.ItemGroup>
        <Carousel.IndicatorGroup class="absolute bottom-24 left-50% z-1 mx-auto flex translate-x--50% gap-x-8" v-if="pages.length > 1">
          <Carousel.Indicator
            class="h-4 w-32 rounded-2 bg-[rgb(0,0,0,0.1)] *:data-[playing]:w-full *:data-[playing]:transition-width *:data-[playing]:duration-4000 *:data-[playing]:transition-ease-linear"
            v-for="idx in pages"
            :key="idx"
            :index="idx"
            :aria-label="`${$t('home.common.carousel.changeTo', { index: idx + 1 }) }`"
          >
            <span class="block h-full w-0 rounded-2 bg-black"></span>
          </Carousel.Indicator>
        </Carousel.IndicatorGroup>
      </Carousel.Context>
    </Carousel.Root>
  </section>
</template>

<style lang="scss" scoped>
</style>
